// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vr-r","label":"styles_label__3i6u_"};